export default __webpack_public_path__ + "static/7-40f4b25d95d4bc1a5cc83654eace5f1c.png";